import { productsRoute, branchRoute, newsArticleRoute, caseStudyRoute, sustainabilityRoute } from '@constants/routes'
import { renderHireProductLink } from './RenderHireProductLink'

export const createTelLink = (phone) => (
  phone ? `tel:+44${phone.replace(/\s+/g, '')}` : null
)

export const createMailtoLink = (email) => (
  `mailto:${email}`
)

export const constructPageLink = (slug, type, category, id) => {
  let link = ''
  switch (type) {
    case 'ContentfulBranchTemplate':
      link = branchRoute(slug)
      break
    case 'ContentfulProductTemplate':
      link = `${productsRoute}/${renderHireProductLink(slug, category)}`
      break
    case 'ContentfulCaseStudyTemplate':
      link = caseStudyRoute(slug)
      break
    case 'ContentfulNewsArticleTemplate':
      link = newsArticleRoute(slug)
      break
    case 'ContentfulProductSubCategoryComponent':
      link = `/${slug}/#category${id}`
      break
    case 'ContentfulSustainabilityTemplate':
      link = sustainabilityRoute(slug)
      break
    default:
      link = `/${slug}`
  }

  return link
}



// WEBPACK FOOTER //
// ./src/helpers/LinkHelper.js